import React, { useContext, useEffect, useState } from 'react';
import Button from '../../components/shared/custom-btn';
import { RxCross2 } from 'react-icons/rx';
import DateTimeLocalInput from '../../components/shared/datetime-input';
import CustomTextarea from '../../components/shared/custom-textarea';
import CustomReactSelect from '../../components/shared/custom-react-selector';
import ModalHeading from '../../components/shared/modal-heading';
import CustomInput from '../../components/shared/custom-input';
import { AccountsContext } from '../../components/context/account-context';
import { createMeter } from '../../services/meters-service';
import { ApiResponseMessage } from '../../components/shared/api-response';
import { prependDefault } from '../../utils/structure-options-utils';
import Loader from '../../components/shared/loader';

const AddModal = ({ handleCloseAddModal, onAdd, types, globalDataloading, openEditModal, fetchGlobalData, vehicle, isVehicleEditable = true, vehicles, fetchMeters }) => {
    const { accountId } = useContext(AccountsContext);
    const [formData, setFormData] = useState({
        time: '',
        vehicle: vehicle ? vehicle.vehicleId : '',
        type: '',
        value: '',
        note: '',
    });
    const [loading, setLoading] = useState(false);
    const [apiResponse, setApiResponse] = useState({ message: '', type: '' });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setApiResponse({ message: '', type: '' });
    };

    const handleSelectChange = (selectedOption, { name }) => {
        setFormData(prev => ({
            ...prev,
            [name]: selectedOption ? selectedOption.value : ''
        }));
        setApiResponse({ message: '', type: '' });
    };

    const handleSave = async (e) => {
        e.preventDefault();
        if (loading || apiResponse.type === 'success') return;
        setLoading(true);
        setApiResponse({ message: '', type: '' });
        try {
            const meterData = {
                vehicleId: formData.vehicle,
                meterTime: formData.time,
                type: formData.type,
                value: parseFloat(formData.value),
                note: formData.note,
            };
            const response = await createMeter(meterData, accountId);
            console.log(response)
            if (response.success) {
                setApiResponse({ message: 'Meter record created successfully!', type: 'success' });
                const newItem = response.data.data;
                onAdd?.(newItem);
                fetchMeters?.('Meters')
                openEditModal?.(newItem);
                setTimeout(() => {
                    handleCloseAddModal();
                }, 1000);
            } else {
                setApiResponse({
                    message: response.data.message || 'Failed to create meter record',
                    type: 'error'
                });
            }
        } catch (error) {
            setApiResponse({
                message: error.message || 'An unexpected error occurred',
                type: 'error'
            });
        } finally {
            setLoading(false);
        }
    };

    const vehicleOptions = prependDefault(vehicles.map(v => ({ value: v.vehicleId, label: v.label })), 'Vehicle');
    const typeOptions = prependDefault(types.map(v => ({ value: v.slug, label: v.label })), 'Type');

    useEffect(() => {
        if (typeof fetchGlobalData === 'function') {
            fetchGlobalData();
        }
    }, []);

    return (
        <form onSubmit={handleSave} className="space-y-2 pt-3 relative">
            <ModalHeading className="text-left mb-3 border-b border-gray-300 px-4 pb-2">
                Add Meter Detail
            </ModalHeading>

            <button
                className='hover:scale-105 absolute -top-2 right-2 bg-white border p-2 rounded-full'
                onClick={handleCloseAddModal}
                disabled={loading}
            >
                <RxCross2 className='text-xl' />
            </button>

            <ApiResponseMessage response={apiResponse} />

            {
                globalDataloading ?
                    <Loader />
                    : (!vehicles || vehicles.length === 0) ? (
                        <div className="flex flex-col items-center justify-center py-10 px-4 text-center">
                            <p className="text-gray-600 text-lg mb-2">There are no vehicles in your account.</p>
                            <p className="text-gray-500">Please create a vehicle to start using this feature.</p>
                        </div>
                    ) :
                        <>
                            <div className="grid grid-cols-1 sm:grid-cols-2 px-4 gap-y-1.5 gap-x-2">
                                <DateTimeLocalInput
                                    label="Time"
                                    name="time"
                                    value={formData.time}
                                    onChange={handleChange}
                                    required={true}
                                    disabled={loading}
                                />

                                <CustomReactSelect
                                    label="Vehicle"
                                    name="vehicle"
                                    value={vehicleOptions.find(opt => opt.value === formData.vehicle)}
                                    onChange={handleSelectChange}
                                    options={vehicleOptions}
                                    placeholder='Select vehicle'
                                    required={true}
                                    isEditable={isVehicleEditable}
                                    isDisabled={loading}
                                />

                                <CustomReactSelect
                                    label="Type"
                                    name="type"
                                    value={typeOptions.find(opt => opt.value === formData.type)}
                                    onChange={handleSelectChange}
                                    options={typeOptions}
                                    placeholder='Select type'
                                    required={true}
                                    isDisabled={loading}
                                />

                                <CustomInput
                                    label="Value"
                                    name="value"
                                    type="number"
                                    value={formData.value}
                                    onChange={handleChange}
                                    inputStyle={'!py-[3px]'}
                                    labelStyle={'text-gray-700'}
                                    labelGap={'!gap-0.5'}
                                    required={true}
                                    decimalMaxDigits={10}
                                    allowDecimalFormat={true}
                                    disabled={loading}
                                />

                                <div className='w-full sm:col-span-2'>
                                    <CustomTextarea
                                        label="Note"
                                        name="note"
                                        value={formData.note}
                                        onChange={handleChange}
                                        placeholder=""
                                        rows={2}
                                        labelStyle={'text-gray-700'}
                                        maxLength={500}
                                        disabled={loading}
                                    />
                                </div>
                            </div>

                            <div className="flex justify-end px-4">
                                <Button
                                    label={'Save'}
                                    loading={loading}
                                    loadingLabel='Saving...'
                                    type='submit'
                                    disabled={loading || apiResponse.type === 'success'}
                                    className={`bg-btnBg rounded-lg !py-1 text-white`}
                                />
                            </div>
                        </>
            }


        </form>
    );
};

export default AddModal;